import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LinkDashedComponent } from './link-dashed/link-dashed.component';


@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    LinkDashedComponent,
  ],
  exports: [
    LinkDashedComponent,
   ],
})
export class LinkModule {}
